<template>
    <div style="height: 100% !important;">
        <!-- <MagazzinoArticoliGiacenzeListComponent v-show="isOperazioneCaricoMagazzino"
            ref="cmpMagazzinoArticoliGiacenzeListComponent" @onRowSelectedArticoliItems="onRowSelectedArticoliItems"
            @onSelectedLottoMatricola="onRowSelectedLottoMatricola" @onAddLottoMatricola="onAddLottoMatricola"
            @updateRowNumberGiacenza="onUpdateRowNumberGiacenza" /> -->
        <div v-show="isOperazioneCaricoMagazzino || isOperazioneInvariataMagazzino"
            style=" height: 100%; overflow-y: auto;">
            <MagazzinoArticoliListComponent @onRowSelectedArticoliItems="onRowSelectedArticoliItems"
                ref="cmpMagazzinoArticoliListComponent" @updateRowNumberGiacenza="onUpdateRowNumberGiacenza"
                :pagination="false" :component="true" :selectable="true"
                :tableHideColumn="['actions', 'codiceAzienda']" />
        </div>
        <div v-show="isOperazioneScaricoMagazzino" style=" height: 100%; overflow-y: auto;">
            <MagazzinoArticoliGiacenzaCodiciComponent ref="cmpMagazzinoArticoliGiacenzaCodiciComponent"
                @updateRowNumberGiacenza="onUpdateRowNumberGiacenza"
                @onRowSelectedArticoliItems="onRowSelectedArticoliItems" :selectable="true" :component="true"
                :tableHideColumn="['actions', 'codiceAzienda']" :pagination="false" />
        </div>
    </div>

</template>

<script>

// import MagazzinoArticoliGiacenzeListComponent from './MagazzinoArticoliGiacenzeListComponent.vue';
import MagazzinoArticoliListComponent from './MagazzinoArticoliListComponent.vue';
import MagazzinoArticoliGiacenzaCodiciComponent from './MagazzinoArticoliGiacenzaCodiciComponent.vue';
import ContabilitaMixin from '../../contabilita/mixins/ContabilitaMixin';
export default {
    mixins: [ContabilitaMixin],
    components: { MagazzinoArticoliGiacenzaCodiciComponent, MagazzinoArticoliListComponent }, //MagazzinoArticoliGiacenzeListComponent
    props: {
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            jsonData: {},
            localData: {},
            rigaDocumento: {},
            isModifica: false,
            customFilter: {},
            filtroMatricolaLotto: {},
            selectedItem: [],
            gestione: false
        }
    },
    computed: {
        isOperazioneCaricoMagazzino() {
            let result = this.jsonData.causaleDocumentoOperazioneMagazzino == 1
            return result;
        },
        isOperazioneInvariataMagazzino() {
            let result = this.jsonData.causaleDocumentoOperazioneMagazzino == 0
            return result;
        },
        isOperazioneScaricoMagazzino() {
            return this.jsonData.causaleDocumentoOperazioneMagazzino == -1;
        }
    },
    methods: {
        init(documentoJson, customFilter, riga) {
            console.log("wrapper filter ", customFilter);
            console.log("wrapper riga ", riga);
            this.isModifica = !!riga.primaryKey;
            console.log("this.isModifica", this.isModifica);
            this.jsonData = documentoJson;
            this.customFilter = customFilter;
            this.rigaDocumento = riga;
            this.loadData();
        },

        setRigaDocumento(riga) {
            // console.log("set riga Documento modifica lotto scadenza", riga.lottiScadenze);
            this.rigaDocumento = riga;
            if (this.$refs.cmpMagazzinoArticoliListComponent) {
                this.$refs.cmpMagazzinoArticoliListComponent.setRigaDocumento(this.rigaDocumento);
            }
            // if (this.$refs.cmpMagazzinoArticoliGiacenzeListComponent) {
            //     this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.setRigaDocumento(riga);
            // }
        },
        loadData() {

            let filtro = {
                codiceStruttura: this.jsonData.strutturaCodice,
                page: this.customFilter.page,
                forPage: this.customFilter.forPage,
                codiceArticolo: this.customFilter.codiceArticolo,
                nomeArticolo: this.customFilter.nomeArticolo,
                lottoMatricola: this.customFilter.lottoMatricola
            }
            if (this.isModifica) {
                filtro.codiceArticolo = this.rigaDocumento.codiceArticolo;
                filtro.nomeArticolo = this.rigaDocumento.descrizione;
            }

            if (this.isOperazioneScaricoMagazzino) {
                this.$refs.cmpMagazzinoArticoliGiacenzaCodiciComponent.loadDataArticoli(filtro);
            } else {
                this.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli(filtro);
            }



            // } else {
            //     let filtro = {
            //         codiceStruttura: this.jsonData.strutturaCodice,
            //         page: this.customFilter.page,
            //         forPage: this.customFilter.forPage,
            //         nomeArticolo: this.customFilter.descrizione,
            //         lottoMatricola: this.customFilter.lottoMatricola
            //     }
            //   
            // }

        },

        onRowSelectedArticoliItems(item) {
            this.selectedItem = item;
            this.emitSelectedItem(item)
        },

        emitSelectedItem(item) {
            this.$emit("onRowSelectedArticoliItems", item)
        },
        onRowSelectedLottoMatricola(item) {
            console.log(item);
            this.$emit("onSelectedLottoMatricola", item)
        },

        onUpdateRowNumberGiacenza(num) {
            this.$emit("updateRowNumberGiacenza", num)
        },
        onAddLottoMatricola(item) {
            this.$emit("onAddLottoMatricola", item)
        }
    }

}
</script>

<style lang="scss" scoped></style>